import { CornerRadius } from '../../../../foundation/cornerRadius/cornerRadius/index.js';

const BadgeSizeXL = {
    size: 24,
    iconSize: 16,
    rectangleIconSize: '100%',
    rectangleWidth: 48,
    radius: CornerRadius.r24,
};
const BadgeSizeLG = {
    size: 20,
    iconSize: 16,
    rectangleIconSize: '100%',
    rectangleWidth: 44,
    radius: CornerRadius.r20,
};
const BadgeSizeMD = {
    size: 16,
    iconSize: 10,
    rectangleIconSize: '100%',
    rectangleWidth: 36,
    radius: CornerRadius.r16,
};
const BadgeSizeSM = {
    size: 12,
    iconSize: 8,
    rectangleIconSize: '100%',
    rectangleWidth: 28,
    radius: CornerRadius.r12,
};

export { BadgeSizeLG, BadgeSizeMD, BadgeSizeSM, BadgeSizeXL };
